﻿import BoatClass from "@/orm/models/BoatClass"
import Ctl from "@/orm/models/Ctl"
import { Model } from 'pinia-orm'
import { DateCast } from 'pinia-orm/casts'
import { Attr, BelongsTo, Cast, Num, Str } from 'pinia-orm/decorators'

export default class CtlClass extends Model {
    static entity = 'ctl-classes'

    @Str( '', { notNullable: true } ) declare id: string
    @Num( 0, { notNullable: true } ) declare ctlId: number
    @BelongsTo( () => Ctl, 'ctlId' ) declare ctl: Ctl
    @Num( 0, { notNullable: true } ) declare boatClassId: number
    @BelongsTo( () => BoatClass, 'boatClassId' ) declare boatClass: BoatClass
    @Num( 0, { notNullable: true } ) declare weight: number
    @Str( null ) declare eventType: string | null
    @Str( '', { notNullable: true } ) declare shortcut: string
    @Str( null ) declare className: string | null
    @Num( null ) declare publicLicenseExceptionType: number | null
    @Num( null ) declare days: number | null
    @Cast( () => DateCast ) @Attr( null ) declare startDate: string | null

    static piniaOptions = {
        persist: true
    }
}
